import { environment } from '../../../../environments/environment'
import { type CartoClient } from '../../ooh/services/carto.helper'

export interface CompareAggregationRow {
  delivery_id: number
  nvisitors_min: number
  nvisitors_max: number
  nvisitors_count: number
  nvisitors_avg: number
  nvisitors_sum: number
  traffic_min: number
  traffic_max: number
  traffic_count: number
  traffic_avg: number
  traffic_sum: number
}

export interface CompareAggregationsFilters {
  delivery_id_1: number
  delivery_id_2: number
  delivery_start_date_1: string
  delivery_start_date_2: string
  filter_combined: string
  columns: string[]
}

export async function fetchCompareAggregations(
  cartoClient: CartoClient,
  filters: CompareAggregationsFilters,
  signal?: AbortSignal,
): Promise<CompareAggregationRow[]> {
  const {
    delivery_id_1,
    delivery_id_2,
    delivery_start_date_1,
    delivery_start_date_2,
    filter_combined,
    columns,
  } = filters

  // CARTO rejects empty array params; ['nvisitors'] is the sentinel the
  // named source recognizes as "no category filter, use the total column".
  const columnsForApi = columns.length === 0 ? ['nvisitors'] : columns

  const response = await cartoClient.query<CompareAggregationRow>({
    source: {
      source: `${environment.CARTO_SOURCE_PREFIX}_compare_aggregations`,
      queryParameters: {
        delivery_id_1,
        delivery_id_2,
        delivery_start_date_1,
        delivery_start_date_2,
        filter_combined,
        columns: columnsForApi,
      },
    },
    params: {
      column: [
        'delivery_id',
        'nvisitors_min',
        'nvisitors_max',
        'nvisitors_count',
        'nvisitors_avg',
        'nvisitors_sum',
        'traffic_min',
        'traffic_max',
        'traffic_count',
        'traffic_avg',
        'traffic_sum',
      ],
    },
    signal,
  })

  return response?.rows ?? []
}
